export { FeaturedArticlesContent, type FeaturedArticlesContentProps } from './components/FeaturedArticlesContent';
export { FeaturedArticles, FeaturedArticlesSkeleton, type FeaturedArticlesProps } from './FeaturedArticles';
